import './ColorOption.scss';

const ColorOption = ({ gradients, selected, onClick }) => {
	console.log('Selected in Option: ', selected);
	const background =
		gradients.length === 1 ? gradients[0] : `linear-gradient(to bottom, ${gradients[0]} 50%, ${gradients[1]} 50%)`;
	return (
		<button
			className={`color-option ${selected ? 'color-option-selected' : ''}`}
			onClick={onClick}
			style={{ '--bg': background }}
		/>
	);
};

export default ColorOption;
